class currentOpenings {
    constructor() {
        this.hiddenFormElm     = document.querySelector('.hidden_form');
        this.ppr               = this.hiddenFormElm.querySelector('.ppr');
        this.boardTokenElm     = this.hiddenFormElm.querySelector('.board_token');
        this.apiBaseUrlElm     = this.hiddenFormElm.querySelector('.api_base_url');
        this.filterCatElm      = document.querySelectorAll('.select-items div');
        this.pagedElm          = this.hiddenFormElm.querySelector('.paged');
        this.maxNumPagedElm    = this.hiddenFormElm.querySelector('.max_page');
        this.nextPaginationElm = document.querySelector('.btn-pagination-next');
        this.prevPaginationElm = document.querySelector('.btn-pagination-prev');
        this.currentJobElm     = document.querySelectorAll('.current-openings-list');
        this.paginationNavElm  = document.querySelectorAll('.page-link-li');
        this.events();
    }
 
    ajaxJobsListings( formData ) {
        var selectTitle        = formData.get('select_title');
        var selectLocation     = formData.get('select_location');
        var ppr                = this.ppr.value;
        var boardToken         = this.boardTokenElm.value;
        var apiBaseUrl         = this.apiBaseUrlElm.value;
        const request          = new XMLHttpRequest();
        let data               = `action=currentJobFilter&ppr=${ppr}&select_title=${selectTitle}&select_location=${selectLocation}&board_token=${boardToken}&api_url=${apiBaseUrl}`;
        request.open('POST', orr_ajax_object.ajaxurl, true);
        request.setRequestHeader(
          'Content-Type',
          'application/x-www-form-urlencoded; charset=UTF-8'
        );
        request.onload = function () {
          if (this.status >= 200 && this.status < 400) {
            var content = JSON.parse(this.response);
            document.querySelector('.max_page').setAttribute('value', document.querySelectorAll('.current-openings-list').length );
            document.querySelector('.current-openings-lists').innerHTML = content.html;
        } else {
            console.log(this.status);
          }
        };
        request.onerror = function () {
          // Connection error
          console.log('error');
        };
        request.send(data);
    }

    change() {
        this.filterCatElm.forEach((element) => {
          element.addEventListener('click', (e) => {
            this.pagedElm.value = 1;
            var form            = document.forms.namedItem('ajaxFilterU');          
            var formData        = new FormData(form);
            var selectLocation  = formData.get('select_location');
            var selectTitle     = formData.get('select_title');
            var existLocation   = selectLocation === "" ? false : true;
            var existTitle      = selectTitle === "" ? false : true;

            this.currentJobElm.forEach((element) => { 
              element.classList.add('d-none');
            });

            if( existLocation && !existTitle )
            {
              jQuery(".location-"+selectLocation).removeClass('d-none');
              document.querySelector(".current-openings-footer").classList.add('d-none');
            }
            else if ( existTitle && !existLocation )
            {
              jQuery(".title-"+selectTitle).removeClass('d-none');
              document.querySelector(".current-openings-footer").classList.add('d-none');
            }
            else if(  existTitle && existLocation )
            {
              jQuery(".location-"+selectLocation+".title-"+selectTitle).removeClass('d-none');
              document.querySelector(".current-openings-footer").classList.add('d-none');
            }
            else if( !existLocation && !existTitle )
            {
              var displayHtmlClass = '.paged-number-1';
              var displayHtmlElm   = document.querySelectorAll(displayHtmlClass);
              displayHtmlElm.forEach((element) => { 
                element.classList.remove('d-none');
              });
              document.querySelector(".current-openings-footer").classList.remove('d-none');
            }
          });
        });
    }
    
    nextPaginationButton()
    {
      this.nextPaginationElm.addEventListener('click', (e) => {
        this.currentJobElm.forEach((element) => { 
           element.classList.add('d-none');
        });
        this.prevPaginationElm.classList.remove('d-none');
        this.pagedElm.value = +this.pagedElm.value + 1;
        var displayHtmlClass = '.paged-number-'+this.pagedElm.value;
        var displayHtmlElm   = document.querySelectorAll(displayHtmlClass);
        displayHtmlElm.forEach((element) => { 
          element.classList.remove('d-none');
        });
        this.pagedElm.setAttribute('value', this.pagedElm.value);
        if ( parseInt( this.pagedElm.value ) >= parseInt( this.maxNumPagedElm.value ) )
        this.nextPaginationElm.classList.add('d-none');
      });
    }

    prevPaginationButton()
    {
      this.prevPaginationElm.addEventListener('click', (e) => {
        this.currentJobElm.forEach( ( element ) => { 
          element.classList.add('d-none');
        });
        this.pagedElm.value = +this.pagedElm.value - 1;
        var displayHtmlClass = '.paged-number-'+this.pagedElm.value;
        var displayHtmlElm   = document.querySelectorAll(displayHtmlClass);
        displayHtmlElm.forEach((element) => { 
          element.classList.remove('d-none');
        });
        this.pagedElm.setAttribute('value', this.pagedElm.value);
        if ( parseInt( this.pagedElm.value ) == 1 )
        this.prevPaginationElm.classList.add('d-none');
      });
    }

    paginationNav()
    {
      this.paginationNavElm.forEach( ( element ) => {
        element.querySelector('a').addEventListener('click', (e) => {
          
          e.preventDefault();
          
          var dataPaged = parseInt( e.target.getAttribute('data-paged') );

          this.pagedElm.setAttribute('value',e.target.getAttribute('data-paged'));
          
          if( dataPaged > 1 )
          {
            this.prevPaginationElm.classList.remove('d-none');
          }

          if( dataPaged < 2 )
          {
            this.prevPaginationElm.classList.add('d-none');
          }
          

          if( dataPaged >= parseInt( this.maxNumPagedElm.value ) )
          {
            this.nextPaginationElm.classList.add('d-none');
          }

          if( dataPaged < parseInt( this.maxNumPagedElm.value ) )
          {
            this.nextPaginationElm.classList.remove('d-none');
          }

          var displayPageNavLinkNum = '.page-link-display-'+( dataPaged + 1);
          
          if ( parseInt( this.pagedElm.value ) < parseInt( this.maxNumPagedElm.value ) )
          {
            document.querySelector(displayPageNavLinkNum).classList.remove('d-none');
          }
           
          this.paginationNavElm.forEach( ( element1 ) => { 
            element1.classList.remove('active');
          });
          this.currentJobElm.forEach( ( element ) => { 
            element.classList.add('d-none');
          });
          var displayHtmlClass = '.'+e.target.getAttribute('data-page-number');
          var displayHtmlElm   = document.querySelectorAll(displayHtmlClass);
          displayHtmlElm.forEach((element2) => { 
            element2.classList.remove('d-none');
          });
          e.target.parentNode.classList.add('active');
        });
      });
    }

    removeDotInPaginationNav()
    {
      var displayPageNavLinkNum = '.page-link-display-'+( parseInt( this.maxNumPagedElm.value ) - 1);
      console.log(displayPageNavLinkNum);
      document.querySelector(displayPageNavLinkNum).addEventListener('click', (e) => {
        document.querySelector('.page-link-display-dot').classList.add('d-none');
      });
    }

    events() {
      this.nextPaginationButton();
      this.prevPaginationButton();
      this.paginationNav();
      this.removeDotInPaginationNav();
      this.change();
    }
}

export default currentOpenings;
new currentOpenings();
